import React from 'react'
import Skeletons from '../../Skeletons'

function AuctionSkeleton(props) {
    return (
        <div className={`auctionSkeleton ${props.theme ? props.theme : ''}`}>
            <Skeletons type="banner" />
        </div>
    )
}

export default AuctionSkeleton
